<template>
  <header
    class="fixed top-0 left-0 w-full z-50 transition-all duration-300"
    :class="scrolled ? 'bg-[#0F1117] shadow-2xl' : 'bg-transparent'"
  >
    <nav class="max-w-7xl mx-auto px-6">
      <div class="flex items-center justify-between h-16 md:h-20">

        <!-- Logo -->
        <router-link to="/" class="flex items-center gap-3 flex-shrink-0">
          <img src="/img/2.png" alt="Kigali Rwanda Car Hire Logo" class="w-9 h-9 object-contain" />
          <div class="hidden sm:block">
            <span class="text-white font-bold text-sm leading-tight block">Kigali Rwanda Car Hire</span>
            <span class="text-brand-light text-xs font-medium">Premium Car Rental</span>
          </div>
        </router-link>

        <!-- Desktop Navigation -->
        <div class="hidden lg:flex items-center gap-8">
          <router-link
            v-for="link in navLinks"
            :key="link.to"
            :to="link.to"
            class="text-white/80 hover:text-brand-light text-sm font-medium tracking-wider transition-colors duration-200 relative group py-2"
            :class="{ 'text-brand-light': $route.path === link.to }"
          >
            {{ link.label }}
            <span
              class="absolute bottom-0 left-0 h-0.5 bg-brand rounded-full transition-all duration-300"
              :class="$route.path === link.to ? 'w-full' : 'w-0 group-hover:w-full'"
            ></span>
          </router-link>
        </div>

        <!-- Right: Phone + CTA -->
        <div class="hidden lg:flex items-center gap-5">
          <a
            href="tel:+250782336854"
            class="flex items-center gap-2 text-white/70 hover:text-white text-sm transition-colors duration-200"
          >
            <svg class="w-4 h-4 text-brand-light flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
            </svg>
            (+250) 782 336 854
          </a>
          <router-link
            to="/car-listing"
            class="bg-brand hover:bg-brand-dark text-white font-semibold text-sm px-5 py-2.5 rounded-full transition-all duration-200 shadow-lg shadow-brand/20 hover:shadow-brand/40"
          >
            Book Now →
          </router-link>
        </div>

        <!-- Mobile Toggle -->
        <button
          @click="mobileOpen = !mobileOpen"
          class="lg:hidden text-white p-2 rounded-lg hover:bg-white/10 transition-colors duration-200"
          aria-label="Toggle menu"
        >
          <svg v-if="!mobileOpen" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
          <svg v-else class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Mobile Menu -->
      <div
        v-show="mobileOpen"
        class="lg:hidden border-t border-white/10 py-4 space-y-1 bg-[#0F1117]"
      >
        <router-link
          v-for="link in navLinks"
          :key="link.to"
          :to="link.to"
          @click="mobileOpen = false"
          class="flex items-center px-4 py-3 text-white/80 hover:text-brand-light hover:bg-white/5 rounded-lg font-medium transition-all duration-200 text-sm"
          :class="{ 'text-brand-light bg-white/5': $route.path === link.to }"
        >
          {{ link.label }}
        </router-link>
        <div class="pt-4 mt-2 border-t border-white/10 flex flex-col gap-3 px-4">
          <a href="tel:+250782336854" class="flex items-center gap-2 text-white/60 text-sm">
            <svg class="w-4 h-4 text-brand-light" fill="currentColor" viewBox="0 0 20 20">
              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
            </svg>
            (+250) 782 336 854
          </a>
          <router-link
            to="/car-listing"
            @click="mobileOpen = false"
            class="bg-brand hover:bg-brand-dark text-white font-semibold text-sm px-5 py-3 rounded-full text-center transition-colors duration-200"
          >
            Book Now →
          </router-link>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'HeaderItem',
  data () {
    return {
      scrolled: false,
      mobileOpen: false,
      navLinks: [
        { to: '/', label: 'HOME' },
        { to: '/car-listing', label: 'CARS' },
        { to: '/about', label: 'ABOUT' },
        { to: '/clients-review', label: 'REVIEWS' },
        { to: '/destinations', label: 'DESTINATIONS' },
        { to: '/blog', label: 'BLOG' },
        { to: '/contact', label: 'CONTACT' }
      ]
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll, { passive: true })
  },
  beforeUnmount () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      this.scrolled = window.scrollY > 60
    }
  }
}
</script>
